export default __webpack_public_path__ + "assets/lowest.95aa5fc0c3a56f12c772acd91594abed.mp3";